import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-policy',
  templateUrl: './yc-refund-policy.component.html',
  styleUrls: ['./yc-refund-policy.component.css']
})
export class YcRefundPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
